import VideoPlayerSpinner from './VideoPlayerSpinner'

export default VideoPlayerSpinner
// eslint-disable-next-line import/export
export * from './VideoPlayerSpinner'
